import { type PaymentMethodType } from './constants';

export const getPaymentMethodKey = (paymentMethod: any): PaymentMethodType => {
  if (!paymentMethod) return 'credit_card';
  const type = (paymentMethod.type || paymentMethod.brand || '').toLowerCase();
  if (type.includes('debit')) return 'debit_card';
  if (type.includes('ach') || type.includes('bank')) return 'ach';
  if (type.includes('check')) return 'check';
  return 'credit_card';
};


